// extracted by mini-css-extract-plugin
module.exports = {"lenders":"_1JUauEUl","darkenedBorder":"_16b35nT_","noBorder":"_3QIJ3q8h","background":"_1wLBchRB"};